import { useDispatch, useSelector } from "react-redux";

// Custom hook that properly handles async dispatch
export const useAppDispatch = () => {
  const dispatch = useDispatch();

  // Return a function that can handle async actions
  return (action) => {
    if (typeof action === "function") {
      // This is a thunk, call it and return the promise
      return action(dispatch);
    }
    // Regular action, dispatch normally
    return dispatch(action);
  };
};

export const useAppSelector = useSelector;
